/**
 * Shown on Your Plan in place of the self-funding figures once self-funding access has expired: when
 * it ended, that the accounts and plan are kept, and a way to renew. Nothing is deleted at expiry.
 */
import { Button, Card, CardContent } from '@design-system';
import { useSelfFundRenewal } from '../hooks/use-self-fund-renewal';

const endedOn = (endsAt: string | null) =>
  endsAt
    ? new Date(endsAt).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      })
    : null;

export function SelfFundRenewalCard({
  clientId,
  endsAt,
}: {
  clientId: string;
  endsAt: string | null;
}) {
  const { renew } = useSelfFundRenewal(clientId);
  const date = endedOn(endsAt);

  return (
    <Card
      className="py-4"
      data-testid="self-fund-renewal"
    >
      <CardContent className="flex flex-col items-end gap-3 px-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
        <p className="text-sm text-gray-950">
          {date
            ? `Your self-funding access ended on ${date}.`
            : 'Your self-funding access has ended.'}{' '}
          Your accounts and plan are saved. Renew to see how your savings could cover care and to
          get your full report.
        </p>
        <Button
          className="shrink-0 rounded-full"
          onClick={renew}
        >
          Renew self-funding access
        </Button>
      </CardContent>
    </Card>
  );
}
